
const authFormShell = {
  email: '',
  username: '',
  password: ''
};

export {
  authFormShell
}